import type { ReactNode } from 'react';

import { CheckboxInput, CheckboxLabel } from './Checkbox.styled';

type Props = {
  'aria-label'?: string;
  'aria-labelledby'?: string;
  qaId?: string;
  id?: string;
  name?: string;
  label?: ReactNode;
  placeholder?: string | null | undefined;
  required?: boolean;
  value?: string | null | undefined;
  checked: boolean;
  hasError?: boolean;
  onChange: (checked: boolean) => void;
  labelPlacement?: 'left' | 'right';
  disabled?: boolean;
  large?: boolean;
};

export function Checkbox({
  id,
  name,
  label,
  checked,
  hasError,
  onChange,
  labelPlacement = 'right',
  disabled,
  large,
  value,
  qaId,
  placeholder,
  ...props
}: Props) {
  const wrappedLabel = label && <span>{label}</span>;

  return (
    <CheckboxLabel
      htmlFor={id}
      $hasError={Boolean(hasError)}
      $hasText={Boolean(label)}
    >
      {labelPlacement === 'left' && wrappedLabel}

      <div /* This div needs to be here for proper line-height alignment */>
        <CheckboxInput
          $large={Boolean(large)}
          value={value ?? 'on'}
          type="checkbox"
          name={name}
          id={id}
          checked={checked}
          onChange={(e) => {
            e.stopPropagation();
            onChange(e.target.checked);
          }}
          disabled={disabled}
          placeholder={placeholder ?? ''}
          data-qa-id={qaId}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </div>

      {labelPlacement === 'right' && wrappedLabel}
    </CheckboxLabel>
  );
}
